import React from 'react';
import { render, hydrate } from 'react-dom';
import * as Sentry from '@sentry/browser';

import App from '../src/apps/desktop';
import config from '../src/config';

if (config.SENTRY_DSN) {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: 'desktop',
  });
}

const mount = document.getElementById('main-root');
const mountFn = mount.hasChildNodes() ? hydrate : render;
mountFn(<App />, mount);
